import { createSelector, Selector } from "@ngxs/store";
import { FirmState, FirmStateModel } from "./firm.state";

export class FirmGetterState {
  @Selector([FirmState])
  static getSearchFirms(state: FirmStateModel) {
    return state.searchResultIds.map(id => state.entities[id]).sort((a, b) => b.score - a.score);
  }

  @Selector([FirmState])
  static getIsLoadingFirm(state: FirmStateModel) {
    return state.isLoadingFirm;
  }

  @Selector([FirmState])
  static getIsValidatingFirms(state: FirmStateModel) {
    return state.isValidatingFirms;
  }

  @Selector([FirmState])
  static getValidFirmsList(state: FirmStateModel) {
    return state.firmIdsValidation.valid;
  }

  @Selector([FirmState])
  static getInvalidFirmsList(state: FirmStateModel) {
    return state.firmIdsValidation.invalid;
  }

  @Selector([FirmState])
  static getFirmConsultId(state: FirmStateModel) {
    return state.selectedFirmId;
  }

  @Selector([FirmState])
  static getLoadingMessage(state: FirmStateModel) {
    return state.loadingMessage || 'Sending request to the server ...';
  }

  @Selector([FirmState])
  static getLoadingMessageIsError(state: FirmStateModel) {
    return state.loadingMessageIsError || false;
  }

  static getFirmById(id: string) {
    return createSelector(
      [FirmState],
      (state: FirmStateModel) => (state.entities && state.entities[id]) || null
    );
  }
}
